// extracted by mini-css-extract-plugin
export var dividerLine = "_8x-3";
export var itemImage = "_8x-9";
export var lightDivider = "_8x-4";
export var modalContent = "_8x-5";
export var modalContentCompact = "_8x-6";
export var productCard = "_8x-a";
export var productImage = "_8x-b";
export var productImageCompact = "_8x-7";
export var productImagePlaceholder = "_8x-c";
export var productImagePlaceholderCompact = "_8x-8";
export var progressBarBackground = "_8x-1";
export var progressBarContainer = "_8x-0";
export var progressBarFill = "_8x-2";